<template>
  <div class="form-item-label">
    <div class="form-item-label-text">{{ label }}</div>
    <div v-if="required" class="form-item-label-badge form-item-label-badge-required">必須</div>
    <div v-if="!required && optional" class="form-item-label-badge form-item-label-badge-optional">任意</div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    label: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    optional: {
      type: Boolean,
      default: false
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.form-item-label {
  display: flex;
  align-items: center;
}

.form-item-label-text {
  font-size: 14px;
  font-weight: bold;
  line-height: 24px;
}

.form-item-label-badge {
  padding: 0 6px;
  margin: 0 0 0 $spacing-unit;
  font-size: 12px;
  line-height: 18px;
  color: #484848;
  text-align: center;
  background: #fff;
  border-radius: 10px;
}

.form-item-label-badge-required {
  color: #fff;
  background: $danger-color;
}

.form-item-label-badge-optional {
  border: 1px solid $border-color;
}
</style>
